<template>
  <div :class="classObj" class="ccui-app-wrapper">
    <div class="ccui-main-container">
      <!--             应用导航-->
      <div class="border-hr"></div>
      <NavMenu
        ref="topNavMenu"
        :subMenu="menu"
        :appTitle="appTitle"
        :companyTitle="companyTitle"
        :logo="orgLogo"
        dashboard="/"
        class="no-print"
        @ccuiHelp="appHelp"
        @onSubmitSkip="onJump"
      >
      </NavMenu>
      <div class="ccui-main-wrapper">
        <!-- 左侧菜单 -->
        <div
          v-show="sidebar.opened"
          class="ccui-sidebar-wrapper no-print"
          :style="{ position: sidebarPosition }"
        >
          <div :style="{ minHeight: sidebarMinHeight }">
            <sidebar
              :title="subMenuTitle"
              :left-menu="currentMenuArr"
              class="ccui-sidebar-container"
            />
          </div>
        </div>
        <!-- 内容区 -->
        <app-main style="min-height: auto" />
      </div>
    </div>
    <feedback ref="feedbackData"></feedback>
  </div>
</template>

<script>
import { Sidebar, AppMain, NavMenu } from "./components";
import Cookies from "js-cookie";
import arrows from "@/basa/assets/images/arrows.png";
import { getDetail, getLogin } from "@/config/api/login";
import { getArgs } from "@/basa/utils";
import { getExternalExpertDetail } from "@/app/sourceManage/api/expert";
import feedback from "./components/feedback/feedback.vue";

export default {
  name: "Layout",
  components: {
    Sidebar,
    AppMain,
    NavMenu,
    feedback
  },
  data() {
    return {
      companyTitle: "", //组织名称
      appTitle: "", //应用名称
      newVal: "",
      orgLogo:
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/BASA_main/10000121987%40117158/2021/1/6/e3c4684543fa48379707a88c94a087f1.png",
      arrows,
      counter: 0,
      isShowSidebar: false,
      topMenuObj: {},
      routeMenu: [],
      leftMenu: [],
      subMenuTitle: "",
      currentMenuObj: {},
      currentParentMenuObj: {},
      tempMenu: [],
      activeIndex: "2",
      sidebarPosition: "absolute",
      sidebarMinHeight: "calc(100vh - 160px)",
      mainRefreshShow: true
    };
  },
  computed: {
    isShowSimpleFooter() {
      return this.$store.state.app.isShowSimpleFooter;
    },
    menu() {
      console.log(this.$store.state.app.menu, "===888555222");
      return this.$store.state.app.menu || [];
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened
      };
    },
    currentMenuArr() {
      return this.$store.state.app.currentMenuArr;
    }
  },
  created() {
    // 每次加载的时候吧缓存清空
    // let url = this.$route.path;
    // if (url.indexOf("expertManage/expertManages") > -1) {
    //   sessionStorage.setItem("acitveIndex", 1);
    // } else {
    //   sessionStorage.setItem("acitveIndex", 0);
    // }
    this.getDetail();
    window.addEventListener("setItem", () => {
      this.newVal = sessionStorage.getItem("languageChangeHandler1");
    });
  },
  mounted() {
    //关loading
    const loadingOverlay = document.querySelector(".loading-overlay");
    loadingOverlay && (loadingOverlay.style.display = "none");
    if (this.$route.path === "/test/test") {
      return;
    }
    this.setMenuInit();

    const sidebarStatus = Cookies.get("sidebarStatus") - 0;
    this.isShowSidebar = !!sidebarStatus;

    window.addEventListener("scroll", this.windowScroll);
    console.log(this.$refs.topNavMenu);
  },
  watch: {
    newVal(e) {
      this.$refs.feedbackData.dialogFormVisible = e === "true";
    },
    $route(to, from) {
      this.setMenuInit();
    }
  },
  methods: {
    appHelp() {
      this.$router.push("/helpAndSupport");
    },
    setMenuInit() {
      getExternalExpertDetail({ isCurrent: 0, isTakeEffect: 0 }).then(res => {
        if (res.data.data && res.data.data.expertDetailBO) {
          console.log(this.$store.state.app.menu, "===888555222");
          this.$store.dispatch("setMenu", this.$store.state.app.menu || []);
        } else {
          this.$store.dispatch(
            "setMenu",
            this.$store.state.app.menu.splice(0, 1) || []
          );
        }
        // 这里控制用哪一级路由来定位菜单
        if (this.$route.matched && this.$route.matched.length > 2) {
          this.setMenu(this.$store.state.app.menu, this.$route.matched[1].name); // 四级用三级的name做定位菜单
        } else {
          this.setMenu(this.$store.state.app.menu, this.$route.name); // this.$route.name 用于定位菜单
        }
      });
    },
    getDetail() {
      getDetail({ agentId: getArgs("a") }).then(res => {
        if (res.data.code === "0") {
          // this.companyTitle = res.data.data.orgFullName;
          this.companyTitle =
            res.data.data.isCommon === 1
              ? "常用功能"
              : res.data.data.orgFullName;
          // localStorage.setItem("orgFullName", this.companyTitle);
          let agentName = res.data.data.agentName;
          // this.orgLogo = res.data.data.orgLogo;
          // 面包屑所用
          this.$store.dispatch("setBreadcrumb", {
            level: "level1",
            data: {
              name: agentName,
              path: "/"
            }
          });
          this.appTitle = agentName;
          this.$store.commit("SET_USER_DETAL", res.data.data);
          sessionStorage.setItem("userDetal", JSON.stringify(res.data.data));
        }
      });
      getLogin({}).then(res => {
        if (res.data.code === "0") {
          this.$store.commit("SET_USER_ID", res.data.data.userId);
        }
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    // 点击菜单
    onJump(obj) {
      this.routeMenu = [];
      this.subMenuTitle = "";
      this.$router.push(obj.url);
    },
    routerObj2MenuObj(item) {
      const menuObj = {};
      menuObj.subMenuTitle = item.name;
      if (item.subMenu.length) {
        const subMenuArr = [];
        item.subMenu.forEach(menuItem => {
          subMenuArr.push(this.trans(menuItem));
        });
        menuObj.subMenu = subMenuArr;
      }
      return menuObj;
    },
    setMenuToRoute(obj) {
      if (obj.subMenu.length) {
        const arr = obj.subMenu;
        const arrMenu = [];

        arr.forEach(item => {
          const menuObj = this.routerObj2MenuObj(item);
          arrMenu.push(menuObj);
        });
        this.$store.dispatch("setCurrentMenuArr", arrMenu);

        this.leftMenu = this.$store.state.app.currentMenuArr;

        this.subMenuTitle = obj.subMenu[0].name;

        const routeObj = this.trans(obj);
        const subMenu = [];
        obj.subMenu.forEach(item => {
          if (item.subMenu.length) {
            item.subMenu.forEach(item => {
              const objTemp = this.trans(item);
              subMenu.push(objTemp);
            });
            routeObj.children = subMenu;
          }
        });

        this.routeMenu = subMenu;
      }
    },
    trans(obj) {
      const _routeObj = {};
      _routeObj.name = obj.name;
      _routeObj.path = obj.url;
      _routeObj.redirect = obj.redirect || "";
      _routeObj.meta = obj.meta || {};
      _routeObj.meta.title = obj.name;
      _routeObj.meta.isNotShow = obj.isNotShow;
      return _routeObj;
    },
    setMenu(arr, menuCode) {
      const that = this;

      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取当前菜单
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
            }
          }
        };
        traverse(arr);
      }
    },
    setParentMenu(arr, pid, index) {
      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取父菜单
              if (arr[i].id === pid) {
                // 获取三级菜单的上级菜单
                if (arr[i].id.split("-").length === 2) {
                  this.currentParentMenuObj = arr[i];
                  arr[i].activeIndex = index;
                  // return
                }
                // 获取二级菜单的上级菜单
                if (arr[i].id.split("-").length === 1) {
                  arr[i].activeIndex = index;
                }

                // 设置上级菜单
                this.setParentMenu(this.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].id === pid) {
                arr[i].activeIndex = index;
              }
            }
          }
        };
        traverse(arr);
      }

      if (
        this.currentParentMenuObj.subMenu &&
        this.currentParentMenuObj.subMenu.length
      ) {
        this.setMenuToRoute(this.currentParentMenuObj);
      }
    },
    windowScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.sidebarPosition = scrollTop >= 120 ? "fixed" : "absolute";
      this.sidebarMinHeight =
        scrollTop >= 120
          ? "calc(100vh - 40px)"
          : `calc(100vh - ${160 - scrollTop}px)`;
    }
  }
};
</script>
<style lang="scss" scoped></style>
